<template>
    <!--TABLA-->
    <div>
        <div>
            <vs-table max-items="20" search  stripe :data="puntos" pagination>
                <template slot="header">
                    <vs-chip color="primary" class="ml-1">Cantidad: {{puntos.length}}</vs-chip>
                    <vs-dropdown v-if="preproformasList.length>0">
                        <vs-button class="btn-drop" type="line" color="danger">Solicitudes pendientes: {{preproformasList.length}}</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item v-for="(tr,soli) in preproformasList" :key="tr">
                                <span>{{ preproformasList[soli] }}</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </template>
                <template slot="thead">
                    <!-- <vs-th>#</vs-th> -->
                    <vs-th width="30%">Detalle Grupo</vs-th>
                    <!-- <vs-th width="15%">Contratos </vs-th> -->
                    <vs-th width="60%">Documentos</vs-th>
                    <vs-th width="10%">Acciones</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <h4>{{ tr.ca_codigo_agrupado }}</h4><br>
                            <b>Tipo:</b>
                            <p v-if="tr.ca_tipo_pedido == 1">Venta directa</p>
                            <p v-if="tr.ca_tipo_pedido == 2">Venta Lista</p><br>
                            <span>{{ tr.ca_descripcion }} </span><br>
                            <span><b>Fecha creación:</b> {{ tr.datoAgrupado[0].created_at }}</span><br>
                            <b>Puntos o Instituciones Proformados:</b>
                            <div class="overflow-y-auto h-24">
                                <ul v-for="(item,key2) in tr.Instituciones" :key="key2">
                                    <li class="my-2" >
                                        <!-- <i class="fa-regular fa-pen-to-square"></i>  -->
                                        <span class="ml-2">{{item.nombreInstitucion}}</span>
                                        <!-- <span v-if="zn_nombre">
                                            (Zona: {{ tr.zn_nombre }})
                                        </span>
                                        <span v-else class="text-danger font-bold">
                                            Sin zona
                                        </span> -->
                                    </li>
                                </ul>
                            </div>
                        </vs-td>
                        <vs-td  height="70%" width="100%">
                            <b><span>Cantidad Contratos: </span>{{ tr.pedidos.length }}</b><br/>
                            <div class="overflow-y-auto" style="max-height: 50px;">
                              <div>
                                  <ul v-for="(item,key2) in tr.pedidos" :key="key2">
                                      <li>{{item.contrato_generado}} <span class="ml-3">( {{item.asesor}} )</span></li>
                                  </ul>
                              </div>
                            </div>
                            <vs-divider></vs-divider>
                            <b v-if="tr.preproformas.length>0"><span>Cantidad Pre-Proformas: </span>{{ tr.preproformas.length }}</b><br/>
                            <b v-if="tr.documentos.length>0"><span>Cantidad Documentos: </span>{{ tr.documentos.length }}</b><br/>
                            <div class="w-full">
                              <table class="w-full">
                                <tr width="100%">
                                  <td width="auto" v-if="tr.preproformas.length>0">
                                      <b>Pre-Proformas</b><br>
                                      <div class="overflow-y-auto" style="max-height: 200px;">
                                          <ul v-for="(item,key2) in tr.preproformas" :key="key2">
                                          <li style="font-size: 13px;">{{item.prof_id}}</li>
                                          </ul>
                                      </div>
                                  </td>
                                  <td width="auto" v-if="tr.documentos.length>0">
                                      <b>Documentos</b> <br>
                                      <div class="overflow-y-auto" style="max-height: 200px;">
                                          <ul v-for="(item2,key3) in tr.documentos" :key="key3">
                                          <li style="font-size: 13px;">{{item2.ven_codigo}}</li>
                                          </ul>
                                      </div>
                                  </td>
                                </tr>
                              </table>
                            </div>
                        </vs-td>
                        <vs-td align="center">
                            <!--ver-->
                            <vs-button color="#de923b" type="border" class="w-full" @click="ver_pedido(tr)">Ventas</vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <!--modales-->
        <vs-popup classContent="popup-example" title="Datos Factura" :active.sync="popupActivoEditar" fullscreen>
            <div v-if="popupActivoEditar">
                <FacturacionInformacionInstitucionVue :institucion_id="ObjectSelected.id_ins_depacho" @changeSaveInformacion="getpuntos"/>
            </div>
        </vs-popup>
    </div>
    </template>

    <script>
    import {
        FormWizard,
        TabContent
    } from 'vue-form-wizard';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    const DatosFacturaVue                       = () => import('../pedidos2/pedidos/institucion/datosFactura/facturadatos.vue');
    const FacturacionInformacionInstitucionVue  = () => import('../pedidos2/pedidos/proforma/components/FacturacionInformacionInstitucion.vue');
    export default {
        components: {
            flatPickr,
            DatosFacturaVue,
            FormWizard,
            TabContent,
            FacturacionInformacionInstitucionVue
        },
        data() {
            return {
                tes: 0,
                responsables: '',
                filtroCedula: '',
                filtrocedula: '',
                ifCrearBeneficiario: false,
                dato: [],
                usuario: [],
                puntos: [],
                preproformasList:[],
                puntosDeVenta: {
                    id: '',
                    email: '',
                    nombreDespacho: '',
                    ruc: '',
                    telefono: '',
                },
                popupActivoEditar: false,
                ObjectSelected: '',
            }
        },
        created() {
            let me = this
            me.usuario = JSON.parse(localStorage.getItem('usuario'));
            me.id_periodo = me.periodoSelect.idperiodoescolar
            me.nombre_periodo = me.periodoSelect.periodoescolar
            localStorage.nombre_periodoPuntos = me.nombre_periodo
        },
        mounted() {
            let me = this;
            me.getpuntos();
            if (me.usuario.id_group == 22) me.userFacturador = true
            if (me.usuario.id_group == 23) me.userAdminFacturador = true
            if (me.usuario.id_group == 27) me.userBodega = true

        },
        props: {
          periodoSelect: {
            type: Object,
            default: {},
          },
        },
        computed: {

            //========================FIN FILTROS PARA BODEGA========================
        },
        methods: {
            f_editarInstitucion(item){
                this.popupActivoEditar  = true;
                this.ObjectSelected     = item;
            },
            ver_pedido(item) {
              let me = this
              this.$store.dispatch('setpuntos', item)
              me.$emit('showWindow', 1)
            },
            editar() {
                let me = this;
                const usuariorespo = localStorage.getItem("usuario");
                const usuarioObjeto = JSON.parse(usuariorespo);
                if (!me.puntosDeVenta.ruc) {
                    me.$vs.notify({
                        text: 'Falta Ruc',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
                if (!me.puntosDeVenta.telefono) {
                    me.$vs.notify({
                        text: 'Falta Telefono',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
                if (!me.puntosDeVenta.email) {
                    me.$vs.notify({
                        text: 'Falta Email',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
                let formData = new FormData();
                formData.append('idInstitucion', me.puntosDeVenta.id);
                formData.append('ruc', me.puntosDeVenta.ruc);
                formData.append('telefonoInstitucion', me.puntosDeVenta.telefono);
                formData.append('email', me.puntosDeVenta.email);
                formData.append('direccionInstitucion', me.puntosDeVenta.direccion);
                me.$vs.loading()
                this.$http.post(this.$server_url + "editarInstitucionDespacho", formData)
                    .then(res => {
                        me.$vs.loading.close()
                        me.$vs.notify({
                            text: 'Guardado con exito',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                        this.popupActivoEditar = false;
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 500) {
                            me.$vs.notify({
                                text: 'Revise los campos que esten en el formato correcto',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-x'
                            })
                            me.$vs.loading.close()
                            this.popupActivoEditar = false;
                        } else {
                            me.$vs.loading.close()
                            this.popupActivoEditar = false;
                            me.$vs.notify({
                                text: 'No se pudo editar',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-x'
                            })
                        }
                    })
            },
            getpuntos() {
                let me = this;
                me.puntos = [];
                me.preproformasList = [];
                me.$vs.loading()
                me.$http.get(me.$server_url + "pedidos2/pedidos?getInstitucionesDespacho=1&id_periodo=" + me.periodoSelect.idperiodoescolar)
                    .then(function (res) {
                        me.puntos = res.data
                        if (me.puntos.length == 0) {
                            me.$vs.notify({
                                text: 'No hay puntos de venta asignados para despachos en este período.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-x'
                            })
                            me.$vs.loading.close()
                        }
                        me.puntos.forEach(item => {
                        const tienePreproformasNull = item.preproformas.some(preproforma => (preproforma.prof_id === null || preproforma.emp_id === null) && preproforma.prof_estado==1);
                            if (tienePreproformasNull) {
                                me.preproformasList.push(item.ca_codigo_agrupado);
                            }
                        });
                        me.$vs.loading.close()
                        // console.log(me.preproformasList);
                    })
            },
        }
    }
    </script>

    <style lang="scss" scoped>
    .header-sidebar {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;

        h4 {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            >button {
                margin-left: 10px;
            }
        }
    }

    .active {
        font-weight: bold;
        color: #269CE3;
        background-color: #F0F5F9;
        padding: 2px 0px;
        border-radius: 5px;
    }

    .menutitle {
        font-weight: bold;
        font-size: 17px;
    }

    .submenu {
        display: flex;
        flex-direction: column;
        margin-top: 5px;
    }

    .submenutitle {
        padding: 5px 0px;
        margin-top: 8px;
        cursor: pointer;
        transition: 0.2s ease-in all;
        font-size: 12px;
    }

    .submenutitle:hover {
        text-decoration: underline;
        color: #41A7E5;
    }

    .fade-in {
        opacity: 1;
        animation-name: fadeInOpacity;
        animation-iteration-count: 1;
        animation-timing-function: ease-in;
        animation-duration: 0.2s;
    }

    @keyframes fadeInOpacity {
        0% {
            opacity: 0;
        }

        50% {
            opacity: 0.7;
        }

        100% {
            opacity: 1;
        }
    }
    </style>
